import { filter, map } from "rxjs/operators";
import { selectIsTutorialBuilding } from "../../../../selectors/selectTutorial";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { guard } from "../../../guards/guard";
import { pathEmpty } from "../../../guards/pathEmpty";
import { TypeActionBuildings } from "../actionBuildings";
import { checkCanCollectProduct } from "../checks/checkCanCollectProduct";
import { pathBuildingOpenQuickSell } from "../path/pathBuildingOpenQuickSell";
import { TypeBuildingAction } from "../reducerBuildings";
export var epicBuildingsCollectProducts = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionBuildings.Select &&
            action.action === TypeBuildingAction.Select &&
            selectIsTutorialBuilding(state$.value, action.building);
    }), map(function (action) { return action.building; }), filter(utilBuildings.hasFinishedProduction), guard(state$, deps, pathEmpty)([checkCanCollectProduct(pathBuildingOpenQuickSell)]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsCollectProducts.ts
// module id = 2049
// module chunks = 3